module.exports = __webpack_public_path__ + "static/media/check_green.270903bb.svg";